import React from 'react';

export default function Projects() {

  return (
    <section className="projects section" id="projects">
      <h2 className="section__tittle-1 backcolor0 feature-space">
        <span className="backcolor">Features.</span>
      </h2>

      <div className="projects__container container grid">

      <div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Membership Access</h3>
              <h2 className="projects__title"> Start Managing Smarter with Traki</h2>
              <p className="projects__description"> Join Traki and simplify your daily operations with a powerful all-in-one
    management system. Monitor records, automate renewals, and stay organized —
    all from a single smart dashboard built for efficiency and growth.</p>
            </div>
     <p className="projects-lower-line">
  Take control. Save time. Grow faster.
</p>
     </div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Monthly Plan</h3>
              <h2 className="projects__title">  Flexible Monthly Membership Management</h2>
              <p className="projects__description">   Easily manage members on a month-to-month basis with Traki’s smart system.
      Automatic renewal tracking, secure record updates, and organized member
      data — all handled seamlessly from one powerful dashboard.</p>
            </div>
     <p className="projects-lower-line">
  ✔ Automated Renewals  ✔ Secure Records  ✔ Easy Tracking
</p>       
</div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Member Registration</h3>
              <h2 className="projects__title">Fast, Secure & Organized Member Onboarding</h2>
              <p className="projects__description">      Add members in seconds with Traki’s intelligent management system.
      Secure data storage, automatic tracking, and real-time updates ensure
      every member is managed efficiently and professionally.</p>
            </div>
   <p className="projects-lower-line">
  ✔ Instant Entry  ✔ Secure Data  ✔ Automated Tracking
</p>         
</div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Membership Setup</h3>
              <h2 className="projects__title"> Smart Plan Creation with Automated Control</h2>
              <p className="projects__description">  Design and manage membership plans with Traki’s intelligent system.
      Automated renewals, secure record storage, and real-time tracking give
      you complete control with zero manual hassle.</p>
            </div>
   <p className="projects-lower-line">
  ✔ Flexible Plans  ✔ Auto Renewals  ✔ Real-Time Updates
</p>         
</div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Smart Member Search</h3>
              <h2 className="projects__title">  Powerful, Fast & Accurate Member Lookup</h2>
              <p className="projects__description"> Access member records instantly with Traki’s advanced search engine.
      Filter by name, ID, phone number, or membership type — giving you complete
      control and clarity in just a few clicks.</p>
            </div>
  <p className="projects-lower-line">
  ✔ Instant Results  ✔ Advanced Filters  ✔ Real-Time Data
</p>          
</div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Member Overview</h3>
              <h2 className="projects__title">Full Visibility. Total Control.</h2>
              <p className="projects__description"> Monitor every member’s profile, membership status, renewal history,
      and activity records in real time. Traki ensures all data is securely
      stored, instantly accessible, and professionally organized.</p>
            </div>
    <p className="projects-lower-line">
  ✔ Complete Profiles  ✔ Activity Tracking  ✔ Secure Records
</p>        
</div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Smart Renewal Reminders</h3>
              <h2 className="projects__title">  Never Miss a Renewal Again</h2>
              <p className="projects__description"> With automated expiry alerts sent 3–7 days in advance, Traki helps
      members stay active and businesses maintain consistent renewals —
      all without manual follow-ups.</p>
            </div>
  <p className="projects-lower-line">
  ✔ Auto Notifications  ✔ Timely Alerts  ✔ Zero Manual Tracking
</p>          
</div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Urgent Renewal Alert</h3>
              <h2 className="projects__title">   Only 3 Days Remaining — Stay Active</h2>
              <p className="projects__description"> Traki has detected that the membership is about to expire.
      Renew now to ensure continuous access, protect your data,
      and prevent any interruption in services.</p>
            </div>
    <p className="projects-lower-line">
  ✔ 3 Days Left  ✔ Immediate Action Required  ✔ No Service Disruption
</p>       
</div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Expired Plan</h3>
              <h2 className="projects__title"> Your Membership Has Ended</h2>
              <p className="projects__description">The current plan is no longer active. To regain access to all features,
      renew the membership immediately and resume services seamlessly.</p>
            </div>
   <p className="projects-lower-line">
  ✔ Access Disabled  ✔ Renewal Needed  ✔ Instant Reactivation
</p>         
</div>

<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Account Inactive</h3>
              <h2 className="projects__title">  Access Paused — Reactivation Required</h2>
              <p className="projects__description">   This account is currently inactive. Activate the membership to
      resume full access, restore services, and maintain seamless operations.</p>
            </div>
  <p className="projects-lower-line">
  ✔ Access Paused  ✔ Reactivation Available  ✔ Instant Restore
</p>          
</div>
<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Membership Renewal</h3>
              <h2 className="projects__title">  Reactivate & Continue Without Interruption</h2>
              <p className="projects__description"> Extend your membership for another 30 days and regain full access
      to all exclusive features. Renew today to ensure seamless operations
      and uninterrupted service.</p>
            </div>
     <p className="projects-lower-line">
  ✔ 30-Day Extension  ✔ Instant Activation  ✔ No Service Disruption
</p>
</div>
<div className='projects__card'>
            <div className="projects__content">
              <h3 className="projects__subtitle">Smart Email Automation</h3>
              <h2 className="projects__title"> Never Miss a Renewal with Automated Alerts</h2>
              <p className="projects__description"> Our intelligent system sends timely email reminders at
      3, 2, and 1 day before expiry, on the expiration date,
      and 1 day after — helping maintain continuous access
      and improving renewal success rates.</p>
            </div>
            <p className="projects-lower-line">
  ✔ 5-Step Reminder System  ✔ Fully Automated  ✔ Improved Renewals
</p>
</div>


</div>
    </section>
  );
}
